/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Zpět nahoru`
};

const da_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Tilbage til toppen`
};

const de_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Nach oben`
};

const en_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Back to top`
};

const es_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Volver arriba`
};

const fr_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Revenir en haut`
};

const hu_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Vissza a tetejére`
};

const it_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Torna all'inizio`
};

const nl_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Terug naar boven`
};

const pl_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Wróć do góry`
};

const pt_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Voltar ao topo`
};

const sv_back_to_top = /** @type {(inputs: {}) => string} */ () => {
	return `Tillbaka till toppen`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const back_to_top = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.back_to_top(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("back_to_top", locale)
	if (locale === "cs") return cs_back_to_top(inputs)
	if (locale === "da") return da_back_to_top(inputs)
	if (locale === "de") return de_back_to_top(inputs)
	if (locale === "en") return en_back_to_top(inputs)
	if (locale === "es") return es_back_to_top(inputs)
	if (locale === "fr") return fr_back_to_top(inputs)
	if (locale === "hu") return hu_back_to_top(inputs)
	if (locale === "it") return it_back_to_top(inputs)
	if (locale === "nl") return nl_back_to_top(inputs)
	if (locale === "pl") return pl_back_to_top(inputs)
	if (locale === "pt") return pt_back_to_top(inputs)
	return sv_back_to_top(inputs)
};